import { useEffect, useState } from 'react';

export default function BlurredRecoveryPhrase({
  value,
  busy = false,
  loadingLabel = 'Loading recovery phrase…'
}) {
  const [revealed, setRevealed] = useState(false);

  useEffect(() => {
    setRevealed(false);
  }, [value]);

  const displayValue = busy ? loadingLabel : value;

  return (
    <div className="recovery-phrase-wrap">
      <textarea
        id="recovery-phrase"
        name="recovery-phrase"
        className={`recovery-phrase${revealed ? '' : ' recovery-phrase-blurred'}`}
        readOnly
        rows={5}
        value={displayValue}
        autoComplete="off"
        aria-label={revealed ? 'Recovery phrase' : 'Recovery phrase hidden for security'}
        aria-hidden={!revealed && !busy}
        tabIndex={revealed || busy ? 0 : -1}
      />
      {!busy && value && (
        <button
          type="button"
          className="secondary recovery-reveal"
          onClick={() => setRevealed((current) => !current)}
        >
          {revealed ? 'Hide phrase' : 'Reveal phrase'}
        </button>
      )}
    </div>
  );
}
